<div class="modal-header border-0">
  <button
    class="btn-close"
    (click)="modal.dismiss()"
    [gptDataTrack]="'analyses-add-close'"
  >
    <i class="gpicon-close"></i>
  </button>
</div>

<div class="custom-scroll-parent gpx-8">
  <div
    class="modal-body custom-scroll gpx-16 gpx-sm-88 gpb-24 gpb-sm-48 gpt-48"
  >
    <app-questionnaire-host
      [questionnaires]="questionnaires"
      [formFieldAppearance]="GpuFormFieldAppearance.Outline"
      (completed)="onCompleted($event)"
    />
  </div>
</div>
